import { createAction, props } from '@ngrx/store';
import { PaymentOrderCreate } from '../../../models/payment-order-create.model';
import { PaymentInternalCreate } from './../../../models/payment-internal.model';

// Page Actions
export const loadTemplatesSuccess = createAction(
  '[Templates] Load Templates Success',
  props<{ templates: PaymentOrderCreate[] | null }>()
);
export const loadTemplatesFailure = createAction(
  '[Templates] Load Templates Failure',
  props<{ error: any }>()
);

export const selectedPaymentTemplates = createAction(
  '[Templates selected template Component] Unsigned ordersId component',
  props<{ data: PaymentOrderCreate | null }>()
);

export const resetSelectedPaymentTemplates = createAction(
  '[Reset Templates ] Reset Templates component'
);

export const setTemplateDetails = createAction(
  '[Templates details] Templates details  Component',
  props<{ templateDetails: PaymentOrderCreate | null }>()
);

export const setTemplateDetailsForm = createAction(
  '[Templates details dropdown form ] Templates details dropdown Component',
  props<{
    templateDetailsForm: PaymentOrderCreate | null;
  }>()
);

export const resetTemplateDetailsForm = createAction(
  '[Reset  Templates details Form] Reset Details Form'
);

export const confirmPaymentOrderForm = createAction(
  '[Templates confirm payment ] Templates  confirm payment',
  props<{ paymentOrderDetailsForm: PaymentOrderCreate | null }>()
);

export const internalPaymentOrder = createAction(
  '[Templates internal order payment ] Templates internal order payment',
  props<{ internalOrderDetailsForm: PaymentInternalCreate | null }>()
);

// API actions
export const loadTemplatesAPI = createAction('[Templates] Load Templates API');
